// Field emoji mapping for UI display
export const fieldEmojis: { [key: string]: string } = {
    'Nom': '👤',
    'Prénom': '👤',
    'Email': '📧',
    'Téléphone': '📞',
    'Localisation': '📍',
    'Département': '📍',
    'Code postal': '📮',
    'Âge': '🎂',
    'Revenu annuel': '💰',
    'Profession': '💼',
    'Situation professionnelle': '💼',
    'Type de couverture souhaitée': '📋',
    'Antécédents médicaux': '🏥',
    'Situation familiale': '👥',
    'Contrat': '📄',
    'Objectif': '🎯',
    'Montant souhaité': '💵',
    'Montant de facture électricité': '💡',
    'Combustible': '🔥',
    'Superficie': '📐',
    'Réside dans une maison': '🏠',
    'Réside dans un appartement': '🏢',
    'Budget estimé': '💰',
    'Type de chauffage': '🔥',
    'Propriétaire': '🔑',
    "Niveau d'études actuel": '🎓',
    "Domaine d'intérêt pour la formation": '📚',
    'Objectif de la formation': '🎯',
    'Temps disponible pour la formation': '⏰',
    'Budget': '💰',
    "Nombre d'années travaillées en France": '📅',
    'Type de service recherché (droit de la famille, immobilier, entreprise, etc.)': '⚖️',
    'Problématique juridique spécifique': '📋',
    'Urgence du besoin': '⚠️',
    'Revenus': '💰',
    'Type de transport recherché (voiture, transport public, vélo, etc.)': '🚗',
    "Fréquence d'utilisation": '📊',
    'Type de service (location, abonnement, etc.)': '📋',
    'Adresse actuelle': '📍',
    'Nouvelle adresse': '📍',
    "Nombre d'objets à déménager": '📦',
    'Date du déménagement': '📅',
    'Besoins supplémentaires (emballage, démontage, etc.)': '📋',
    'Signe Astro': '⭐',
    "Lien avec l'ésotérisme": '🔮',
    'Problématique ou question spécifique': '❓',
    'Type de consultation recherchée': '🔮',
    'Situation de vie (retraité, en activité, etc.)': '👴',
    'Besoins spécifiques (domicile, santé, loisirs, etc.)': '📋',
    'Revenus mensuels': '💰',
    'Type de services recherchés (aide à domicile, loisirs, etc.)': '🏥',
    'Budget alloué': '💰',
    'Type de problème à résoudre (plomberie, électricité, toiture, etc.)': '🔧',
    'Type de bien (maison, appartement)': '🏠',
    "Urgence de l'intervention": '⚠️',
    'Disponibilité du client': '📅',
    'Type de travaux': '🛠️',
    'Délai du projet': '📅',
    'Investissement immobilier (LMNP, SCPI)': '🏢',
    'Immobilier commercial': '🏢',
    'Immobilier neuf': '🏗️',
    'Crédit immobilier': '💳',
    'Renégociation crédit immobilier': '💳',
    'Revenus annuels': '💰',
    'Situation financière': '💼',
    "Type d'investissement recherché": '📊',
    "Objectifs d'investissement": '🎯',
    'Montant des impots': '💰',
    'Epargne à investir': '💵',
    'Aversion au risque': '⚠️',
    'Type de voyage recherché': '✈️',
    'Destination préférée': '🌍',
    'Durée du séjour': '📅',
    'Nombre de personnes': '👥',
    'Mode de transport préféré': '🚗',
    'Objectifs de santé (perte de poids, bien-être mental, remise en forme, etc.)': '🏃',
    'Habitudes alimentaires': '🍎',
    'Activité physique': '💪',
    'Type de bien recherché': '🏠',
    'Statut (Achat/Location)': '🔑',
    'Échéance': '📅',
    'Type de bien (Maison/Appartement)': '🏠',
    'Statut (Propriétaire/Locataire)': '🔑',
    "Type d'installation souhaitée": '⚡',
    "Type d'assurance": '📋',
    'Date de renouvellement': '📅',
    'Type de produit recherché': '📋',
    'Type de couverture': '📋',
    'Date de début souhaitée': '📅',
    'Objectif professionnel': '💼',
    'Type de véhicule': '🚗',
    'Motorisation souhaitée': '⚙️',
    "Délai d'achat": '📅',
    'Besoin spécifique': '📋',
    'Délai': '📅',
};

export const H1 = [
    'Ain (01)',
    'Aisne (02)',
    'Allier (03)',
    'Hautes-Alpes (05)',
    'Ardennes (08)',
    'Aube (10)',
    'Calvados (14)',
    'Cantal (15)',
    'Corrèze (19)',
    'Côte-d’Or (21)',
    'Creuse (23)',
    'Doubs (25)',
    'Eure (27)',
    'Eure-et-Loir (28)',
    'Isère (38)',
    'Jura (39)',
    'Loire (42)',
    'Haute-Loire (43)',
    'Loiret (45)',
    'Marne (51)',
    'Haute-Marne (52)',
    'Meurthe-et-Moselle (54)',
    'Meuse (55)',
    'Moselle (57)',
    'Nièvre (58)',
    'Nord (59)',
    'Oise (60)',
    'Orne (61)',
    'Pas-de-Calais (62)',
    'Puy-de-Dôme (63)',
    'Bas-Rhin (67)',
    'Haut-Rhin (68)',
    'Rhône (69)',
    'Haute-Saône (70)',
    'Saône-et-Loire (71)',
    'Savoie (73)',
    'Haute-Savoie (74)',
    'Paris (75)',
    'Seine-Maritime (76)',
    'Seine-et-Marne (77)',
    'Yvelines (78)',
    'Somme (80)',
    'Haute-Vienne (87)',
    'Vosges (88)',
    'Yonne (89)',
    'Territoire de Belfort (90)',
    'Essonne (91)',
    'Hauts-de-Seine (92)',
    'Seine-Saint-Denis (93)',
    'Val-de-Marne (94)',
    'Val-d’Oise (95)',
];

export const H2 = [
    'Alpes-de-Haute-Provence (04)',
    'Ardèche (07)',
    'Ariège (09)',
    'Aveyron (12)',
    'Charente (16)',
    'Charente-Maritime (17)',
    'Cher (18)',
    'Côtes-d’Armor (22)',
    'Dordogne (24)',
    'Drôme (26)',
    'Finistère (29)',
    'Haute-Garonne (31)',
    'Gers (32)',
    'Gironde (33)',
    'Ille-et-Vilaine (35)',
    'Indre (36)',
    'Indre-et-Loire (37)',
    'Landes (40)',
    'Loir-et-Cher (41)',
    'Loire-Atlantique (44)',
    'Lot (46)',
    'Lot-et-Garonne (47)',
    'Lozère (48)',
    'Maine-et-Loire (49)',
    'Manche (50)',
    'Mayenne (53)',
    'Morbihan (56)',
    'Pyrénées-Atlantiques (64)',
    'Hautes-Pyrénées (65)',
    'Sarthe (72)',
    'Deux-Sèvres (79)',
    'Tarn (81)',
    'Tarn-et-Garonne (82)',
    'Vaucluse (84)',
    'Vendée (85)',
    'Vienne (86)',
];

export const H3 = [
    'Alpes-Maritimes (06)',
    'Aude (11)',
    'Bouches-du-Rhône (13)',
    'Corse (20)',
    'Gard (30)',
    'Hérault (34)',
    'Pyrénées-Orientales (66)',
    'Var (83)',
];

export const frenchAreas = [
    '🇫🇷 Toute la France',
    '🇧🇪 Toute la Belgique',
    '🇨🇭 Toute la Suisse',
    "🇪🇸 Toute l'Espagne",
    'Zone Climatique H1',
    'Zone Climatique H2',
    'Zone Climatique H3',
    'Ain (01)',
    'Aisne (02)',
    'Allier (03)',
    'Alpes-de-Haute-Provence (04)',
    'Hautes-Alpes (05)',
    'Alpes-Maritimes (06)',
    'Ardèche (07)',
    'Ardennes (08)',
    'Ariège (09)',
    'Aube (10)',
    'Aude (11)',
    'Aveyron (12)',
    'Bouches-du-Rhône (13)',
    'Calvados (14)',
    'Cantal (15)',
    'Charente (16)',
    'Charente-Maritime (17)',
    'Cher (18)',
    'Corrèze (19)',
    'Corse-du-Sud (2A)',
    'Haute-Corse (2B)',
    "Côte-d'Or (21)",
    "Côtes-d'Armor (22)",
    'Creuse (23)',
    'Dordogne (24)',
    'Doubs (25)',
    'Drôme (26)',
    'Eure (27)',
    'Eure-et-Loir (28)',
    'Finistère (29)',
    'Gard (30)',
    'Haute-Garonne (31)',
    'Gers (32)',
    'Gironde (33)',
    'Hérault (34)',
    'Ille-et-Vilaine (35)',
    'Indre (36)',
    'Indre-et-Loire (37)',
    'Isère (38)',
    'Jura (39)',
    'Landes (40)',
    'Loir-et-Cher (41)',
    'Loire (42)',
    'Haute-Loire (43)',
    'Loire-Atlantique (44)',
    'Loiret (45)',
    'Lot (46)',
    'Lot-et-Garonne (47)',
    'Lozère (48)',
    'Maine-et-Loire (49)',
    'Manche (50)',
    'Marne (51)',
    'Haute-Marne (52)',
    'Mayenne (53)',
    'Meurthe-et-Moselle (54)',
    'Meuse (55)',
    'Morbihan (56)',
    'Moselle (57)',
    'Nièvre (58)',
    'Nord (59)',
    'Oise (60)',
    'Orne (61)',
    'Pas-de-Calais (62)',
    'Puy-de-Dôme (63)',
    'Pyrénées-Atlantiques (64)',
    'Hautes-Pyrénées (65)',
    'Pyrénées-Orientales (66)',
    'Bas-Rhin (67)',
    'Haut-Rhin (68)',
    'Rhône (69)',
    'Haute-Saône (70)',
    'Saône-et-Loire (71)',
    'Sarthe (72)',
    'Savoie (73)',
    'Haute-Savoie (74)',
    'Paris (75)',
    'Seine-Maritime (76)',
    'Seine-et-Marne (77)',
    'Yvelines (78)',
    'Deux-Sèvres (79)',
    'Somme (80)',
    'Tarn (81)',
    'Tarn-et-Garonne (82)',
    'Var (83)',
    'Vaucluse (84)',
    'Vendée (85)',
    'Vienne (86)',
    'Haute-Vienne (87)',
    'Vosges (88)',
    'Yonne (89)',
    'Territoire de Belfort (90)',
    'Essonne (91)',
    'Hauts-de-Seine (92)',
    'Seine-Saint-Denis (93)',
    'Val-de-Marne (94)',
    "Val-d'Oise (95)",
    'Guadeloupe (971)',
    'Martinique (972)',
    'Guyane (973)',
    'La Réunion (974)',
    'Mayotte (976)',
];

export const allChannels = [
    'Google Ads',
    'Bing Ads',
    'Taboola',
    'Facebook',
    'Instagram',
    'Twitter',
    'LinkedIn',
    'Pinterest',
    'SEO',
    'Emailing',
    'SMS',
    'Newsletter',
    'Display',
    'Tik Tok',
    'Robot I.A',
];
